import { css, Global } from '@emotion/react';
import { motion } from 'motion/react';
import { useThemeValues } from '../../../hooks';
import { ModalBox, ModalBoxProps } from '../atoms';

export const CenteredModalBox = ({ children, ...rest }: ModalBoxProps) => {
  const { zIndex } = useThemeValues();
  return (
    <>
      <Global
        styles={css`
          .wv-modal-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: ${zIndex.modals};

            :focus {
              outline: none;
            }
          }
        `}
      />
      <motion.div
        initial={{
          opacity: 0,
          y: '50%',
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        exit={{
          opacity: 0,
          y: '50%',
        }}
        transition={{
          type: 'spring',
          damping: 24,
          stiffness: 300,
        }}
      >
        <ModalBox {...rest}>{children}</ModalBox>
      </motion.div>
    </>
  );
};
